export const DOCUMENT_STATES = {
    "NOT_STARTED": "notStarted",
    "NOT_COMPLETED": "notCompleted",
    "COMPLETED": "completed"
}